import React from 'react';

const MenuClose = ({mainColor}) => {
    return (
      <svg
        width="24" height="18"
        viewBox="0 0 24 18" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="21.7503" height="2" rx="0.5" transform="matrix(-0.722865 -0.69099 -0.69099 0.722865 20.4402 15.8169)" fill={mainColor}/>
        <rect x="3.33569" y="15.8169" width="21.7503" height="2" rx="0.5" transform="rotate(-43.7085 3.33569 15.8169)" fill={mainColor}/>
      </svg>

    );
};

export default MenuClose;